import { HonchInstance } from '../config';
import { HonchConfig } from '../config';
import { Logger } from '../utils/logger';
import { PageviewTracker } from './pageview';
import { ClickTracker } from './click';
import { FormTracker } from './form';

export class AutoCapture {
    private honch: HonchInstance;
    private config: HonchConfig;
    private logger: Logger;

    private pageviewTracker: PageviewTracker | null = null;
    private clickTracker: ClickTracker | null = null;
    private formTracker: FormTracker | null = null;

    constructor(honch: HonchInstance, config: HonchConfig, logger: Logger) {
        this.honch = honch;
        this.config = config;
        this.logger = logger;
    }

    start(): void {
        this.logger.debug('Starting autocapture');

        if (this.config.autocapture) {
            this.pageviewTracker = new PageviewTracker(this.honch, this.logger);
            this.pageviewTracker.start();
        }

        if (this.config.capture_clicks) {
            this.clickTracker = new ClickTracker(this.honch, this.config, this.logger);
            this.clickTracker.start();
        }

        if (this.config.capture_forms) {
            this.formTracker = new FormTracker(this.honch, this.config, this.logger);
            this.formTracker.start();
        }
    }

    stop(): void {
        this.logger.debug('Stopping autocapture');

        this.pageviewTracker?.stop();
        this.clickTracker?.stop();
        this.formTracker?.stop();

        this.pageviewTracker = null;
        this.clickTracker = null;
        this.formTracker = null;
    }
}
